import { useLocation } from 'react-router-dom';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const location = useLocation();
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const getBaseSchema = () => {
    const pageUrl = `${origin}${location.pathname}`;
    return {
      '@context': 'https://schema.org',
      '@type': type,
      url: pageUrl,
      ...data,
    };
  };

  const schema = getBaseSchema();

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
}